// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8609 ? "278ec004" : chunkId) + "." + {"6427":"49b12dcf61c4a781","7910":"5d0ad41c18cae897","8609":"a4cfa8015b620948"}[chunkId] + ".js";
};